/**
 * thumbnail 재시도 최대 횟수.
 *
 * 서버가 Celery 비동기 작업으로 thumbnail 을 생성하므로 응답 시점에 404 일 수 있다.
 * 이 횟수를 모두 소진해도 ready 가 안 되면 원본 src 로 fallback (HEIC 변환 경로 인계).
 *
 * `ImageCache` 의 `MAX_RESOLVE_ATTEMPTS` 는 이 값을 기준으로 `+ 2` 로 설정된다.
 * 둘 중 하나를 바꾸면 다른 쪽도 자동으로 갱신된다 (ImageCache.ts 참고).
 */
export const MAX_THUMBNAIL_RETRIES = 6;
